
import { useState } from 'react';

function useProvideNotification() {
  const [notifyMessage, setNotifyMessage] = useState(false);

  return { setNotifyMessage, notifyMessage }
}
export default useProvideNotification;